import { Component, inject, Input, OnInit } from '@angular/core';

import { SuspendedReason } from '@ecm/portfolio';
import { LinkService, TrackingData } from '@ecm/router';
import { TrackableView } from '@ecm/tracker';

import { SuspendedViewModel } from '../../../../business/model/common/suspended.view-model';
import { TrackedName } from '../../../../business/model/tracking/trackedName.enum';
import { TrackedPage } from '../../../../business/model/tracking/trackedPage.enum';
import { TrackingService } from '../../../../services/tracking.service';
import { ParamsUtils } from '../../../../utils/params.utils';
import { AbstractParentComponent } from '../../../shared/abstract-parent.component';

@Component({
    selector: 'crossroadSuspendedAlert',
    templateUrl: 'crossroadSuspendedAlert.html',
    styleUrls: ['crossroadSuspendedAlert.css'],
    standalone: true,
})
export class CrossroadSuspendedAlertComponent extends AbstractParentComponent implements OnInit, TrackableView {
    @Input()
    public viewModel: SuspendedViewModel;

    @Input()
    public cid: string;

    @Input()
    public displayButton = false;

    /**
     * GA tracking area
     * @type {string}
     */
    private readonly trackingArea: string = 'care_selecteurcontrat_offre';

    private clickTrackedName: string;
    private viewTrackedName: string;

    private readonly trackingService = inject(TrackingService);
    private readonly linkService = inject(LinkService);

    public constructor() {
        super();
    }

    public ngOnInit(): void {
        super.ngOnInit();
        switch (this.viewModel.suspendedReason) {
            case SuspendedReason.THEFT:
            case SuspendedReason.LOSS:
                this.clickTrackedName = TrackedName.THEFT_LOSS_BUTTON;
                this.viewTrackedName = TrackedName.THEFT_LOSS_VIEW;
                break;
            case SuspendedReason.NONPAYMENT:
                this.clickTrackedName = TrackedName.NON_PAYMENT_BUTTON;
                this.viewTrackedName = TrackedName.NON_PAYMENT_VIEW;
                break;
            default:
                this.clickTrackedName = TrackedName.NON_PAYMENT_PRESAR_BUTTON;
                this.viewTrackedName = TrackedName.NON_PAYMENT_PRESAR_VIEW;
                break;
        }
        // TODO uncomment line when script utags.js is deploy
        // this.onAfterViewLoaded();
    }

    /**
     * @override
     */
    public onAfterViewLoaded(): void {
        this.trackZone();
    }

    /**
     * Open facture-paiement page
     */
    public openLink(): void {
        this.linkService.openLink(
            this.viewModel.button.link,
            Object.assign(new TrackingData(), {
                tmsTracking: {
                    trackedPage: TrackedPage.contractsAndOptions,
                    trackingArea: this.trackingArea,
                    trackingName: this.clickTrackedName,
                },
            }),
            ParamsUtils.cidMap(this.cid),
        );
    }

    /**
     * Tracks zone and TMS
     */
    private trackZone(): void {
        const link = this.linkService.getLinkSync(this.viewModel.button.link);

        this.trackingService.trackSuspendedZone(this.trackingArea, this.viewTrackedName, link);
    }
}
